import { FC } from 'react'

import { Spinner } from '@trustycars/genie-ui/components'
import { TagsNoRef } from '@trustycars/genie-ui/types'
import { propsWithClassNames } from '@trustycars/genie-ui/functions'

import useAutoTransition from '$browser/useAutoTransition'
import useSignal from '$actions/useSignal'
import useLoginAttentions from '$actions/useLoginAttentions'

import AccountPreview from '$elements/AccountPreview'

import { updateCurrent } from '$store/session'
import { profile as profileStore } from '$store/profile'
import { profiles } from '$store/profiles'
import { getAlias } from '$services/user'

import { container, headerLoader, listLoader, main, title } from './styles.css'
import { getPhone } from '$app/utilities'

export const AccountSwitcher: FC<TagsNoRef<'section'>> = containerProps => {
  const [headerRef] = useAutoTransition()
  const [mainRef] = useAutoTransition()

  const profile = useSignal(profileStore)
  const { data: profileList } = useSignal(profiles)

  const { resolveNow } = useLoginAttentions()

  const switchableProfiles = profileList.filter(({ id }) => id !== profile?.id)

  const profileLoading = profile?.loading
  const username = getAlias(profile?.data)

  const afterSwitch = (id: unknown) => {
    const hasAttentions = !!profileList.find(p => p.id === id)?.data
      ?.login_attentions?.length

    if (!hasAttentions) return

    resolveNow()
  }

  return (
    <section {...propsWithClassNames(containerProps, container)}>
      <header ref={headerRef}>
        {profileLoading && (
          <div className={headerLoader}>
            <Spinner />
          </div>
        )}

        {!profileLoading && <h3 className={title}>{username}</h3>}
      </header>

      <main ref={mainRef} className={main}>
        {switchableProfiles.map(({ id, data, loading }) => (
          <article key={id}>
            {loading && (
              <div className={listLoader}>
                <Spinner />
              </div>
            )}

            {!loading && data && (
              <AccountPreview
                name={data.name}
                username={getAlias(data)}
                image={data.profile_photo_url}
                containerProps={{
                  onClick: () => {
                    updateCurrent(id)
                    afterSwitch(id)
                  },
                  'data-testid': `account-id:${data.id} email:${data.email} phone:${getPhone(data)}`
                }}
              />
            )}
          </article>
        ))}
      </main>
    </section>
  )
}

export default AccountSwitcher
